import React from "react";

interface Star2Props {
  width?: number;
  height?: number;
  className?: string;
  opacity?: number;
  isDarkMode?: boolean;
}

const Star2: React.FC<Star2Props> = ({ width = 1408, height = 868, className, opacity = 0.5, isDarkMode = false }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 1408 868" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        opacity={opacity}
        d="M675.959 1246.79C688.864 1267.59 719.139 1267.59 732.044 1246.79L872.252 1020.73C880.736 1007.05 897.853 1001.49 912.758 1007.57L1159.06 1108.04C1181.73 1117.29 1206.22 1099.49 1204.43 1075.07L1184.99 809.782C1183.82 793.728 1194.39 779.168 1210.03 775.326L1468.34 711.834C1492.12 705.99 1501.47 677.198 1485.67 658.494L1314.01 455.295C1303.62 442.998 1303.62 425.001 1314.01 412.704L1485.67 209.505C1501.47 190.801 1492.12 162.009 1468.34 156.165L1210.03 92.6735C1194.39 88.8313 1183.82 74.2709 1184.99 58.2167L1204.43 -207.075C1206.22 -231.494 1181.73 -249.289 1159.06 -240.041L912.758 -139.573C897.853 -133.493 880.736 -139.055 872.252 -152.734L732.044 -378.786C719.139 -399.594 688.864 -399.594 675.959 -378.786L535.751 -152.734C527.267 -139.055 510.15 -133.493 495.245 -139.573L248.945 -240.041C226.274 -249.289 201.781 -231.494 203.571 -207.075L223.011 58.2167C224.187 74.271 213.608 88.8313 197.976 92.6735L-60.3382 156.165C-84.1153 162.009 -93.4705 190.801 -77.6695 209.505L93.9921 412.704C104.38 425.001 104.38 442.998 93.9921 455.295L-77.6695 658.494C-93.4705 677.198 -84.1152 705.99 -60.3381 711.834L197.976 775.326C213.608 779.168 224.187 793.728 223.011 809.782L203.571 1075.07C201.781 1099.49 226.274 1117.29 248.945 1108.04L495.245 1007.57C510.15 1001.49 527.267 1007.05 535.751 1020.73L675.959 1246.79Z"
        fill={isDarkMode ? "url(#paint1_radial_dark_mode)" : "url(#paint0_radial_1227_60530)"}
      />
      <defs>
        <radialGradient
          id="paint0_radial_1227_60530"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(704.001 434) rotate(-90) scale(857.999)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop stopColor="white" offset="0.814095" />
        </radialGradient>

        <radialGradient
          id="paint1_radial_dark_mode"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(569 434) rotate(-90) scale(614)"
        >
          <stop offset="0.610779" stopColor="2D1A2D" stopOpacity="0" />
          <stop offset="0.814095" stopColor="2D1A2D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default Star2;
